document.addEventListener("DOMContentLoaded", function () {
  // Animación de fade-in
  const fadeInElements = document.querySelectorAll(".js-animation-fade-in");
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("fade-in-active");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  fadeInElements.forEach(el => observer.observe(el));

  // Mostrar elementos ocultos en caso de que JS esté habilitado
  document.querySelectorAll(".no-js-hidden").forEach(el => {
    el.classList.remove("no-js-hidden");
  });

  // Cargar imágenes correctamente con lazy loading
  document.querySelectorAll(".img-card-product").forEach(img => {
    if ("loading" in HTMLImageElement.prototype) {
      img.setAttribute("loading", "lazy");
    }
  });
});
